import { combineReducers } from 'redux'
import { ACTIONS } from '../../_config'

import loaderReducer from './loaderReducer'
import userReducer from './userReducer'
import dialogReducer from './dialogReducer'
import TopLearningReducer from './topLearingReducer'
import experimentReducer from './experimentReducer'
import workersReducer from './workerReducer'
import DeepDiveReducer from './deepDiveReducer'
import AdminReducer from './adminReducer'
import insightReportReducer from './insightReportReducer'

const appReducer = combineReducers({
    loader: loaderReducer,
    user: userReducer,
    dialog: dialogReducer,
    topLearning: TopLearningReducer,
    experiment: experimentReducer,
    workers: workersReducer,
    deepDive: DeepDiveReducer,
    admin: AdminReducer,
    insightFilterReport: insightReportReducer,
})

const rootReducer = (state: any, action: any) => {
    if (action.type === ACTIONS.USER.LOGOUT) {
        state = undefined
        localStorage.removeItem('persist:root')
    }

    return appReducer(state, action)
}

export default rootReducer
